import { NgModule } from '@angular/core';

import { FarebasisPerPassengerComponent } from './farebasis-per-passenger.component';
import { CommonModule } from '@angular/common';
import { AccordionModule } from '../accordion/accordion.module';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  imports: [CommonModule, AccordionModule, SharedModule],
  exports: [FarebasisPerPassengerComponent],
  declarations: [FarebasisPerPassengerComponent],
})
export class FarebasisModule { }
